<div class="markdown">
  @for (block of blocks(); track trackBlock($index, block)) {
    @switch (block.kind) {
      @case ('paragraph') {
        <p>
          @for (inline of block.inlines; track trackInline($index, inline)) {
            <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
          }
        </p>
      }
      @case ('heading') {
        @if (block.level === 1) {
          <h1>
            @for (inline of block.inlines; track trackInline($index, inline)) {
              <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
            }
          </h1>
        } @else if (block.level === 2) {
          <h2>
            @for (inline of block.inlines; track trackInline($index, inline)) {
              <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
            }
          </h2>
        } @else {
          <h3>
            @for (inline of block.inlines; track trackInline($index, inline)) {
              <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
            }
          </h3>
        }
      }
      @case ('code-block') {
        <pre><code>{{ block.code }}</code></pre>
      }
      @case ('blockquote') {
        <blockquote>
          @for (inline of block.inlines; track trackInline($index, inline)) {
            <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
          }
        </blockquote>
      }
      @case ('list') {
        @if (block.ordered) {
          <ol>
            @for (item of block.items; track $index) {
              <li>
                @for (inline of item; track trackInline($index, inline)) {
                  <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
                }
              </li>
            }
          </ol>
        } @else {
          <ul>
            @for (item of block.items; track $index) {
              <li>
                @for (inline of item; track trackInline($index, inline)) {
                  <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
                }
              </li>
            }
          </ul>
        }
      }
      @case ('table') {
        <div class="overflow-x-auto">
          <table>
            <thead>
              <tr>
                @for (cell of block.header; track $index) {
                  <th [style.text-align]="block.aligns[$index]">
                    @for (inline of cell; track trackInline($index, inline)) {
                      <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
                    }
                  </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (row of block.rows; track $index) {
                <tr>
                  @for (cell of row; track $index) {
                    <td [style.text-align]="block.aligns[$index]">
                      @for (inline of cell; track trackInline($index, inline)) {
                        <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: inline }" />
                      }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }
    }
  }
</div>

<ng-template #inlineTemplate let-inline>
  @switch (inline.kind) {
    @case ('text') {
      {{ inline.value }}
    }
    @case ('code') {
      <code>{{ inline.value }}</code>
    }
    @case ('strong') {
      <strong>
        @for (nestedInline of inline.inlines; track trackInline($index, nestedInline)) {
          <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: nestedInline }" />
        }
      </strong>
    }
    @case ('em') {
      <em>
        @for (nestedInline of inline.inlines; track trackInline($index, nestedInline)) {
          <ng-container [ngTemplateOutlet]="inlineTemplate" [ngTemplateOutletContext]="{ $implicit: nestedInline }" />
        }
      </em>
    }
    @case ('link') {
      @if (inline.href) {
        <a [href]="inline.href" target="_blank" rel="noopener noreferrer">{{ inline.label }}</a>
      } @else {
        {{ inline.label }}
      }
    }
  }
</ng-template>
